/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../apiHelpers/SlotAPIHelper',
	'../../../visualizations/recommender/IRUtils'
], function (SlotAPIHelper, IRUtils) {
	'use strict';
	return class Utils {
		// translation of top bottom spec into IR. TODO: use a common utility
		static translateTopBottom2IR(tbEntry) {
			const entry = {};
			entry.filterId = tbEntry.id;
			entry.columnId = tbEntry.itemId;
			entry.topBottomType = IRUtils.IRTopBottomType(tbEntry.selection.topBottom.type);
			entry.method = IRUtils.IRTopBottomMethod(tbEntry.selection.topBottom.type);
			entry.domainSize = tbEntry.selection.topBottom.value;
			if (tbEntry.selection.topBottom.context) {
				entry.byColumn = tbEntry.selection.topBottom.context.itemId;
			}
			entry.type = 'TOP_BOTTOM';
			return entry;
		}

		static getTopBottomItems(visualization) {
			const mappedSlots = visualization.getSlots().getMappedSlotList();
			if( !mappedSlots || !mappedSlots.length){
				return;
			}

			const topBottomItems = [];

			// ignore hidden slots which are not considered as part of mappings
			// e.g. 'rank' slot of grid, 'size' slot of scatter
			mappedSlots.filter(slot => slot && !slot.getDefinition().isHidden())
				.forEach( mappedSlot => {
					const dataItemAPIs = Utils.filterInvalidDataItems(mappedSlot.getDataItemList());

					dataItemAPIs
						.forEach(dataItemAPI => {
							const topBottomSpec = dataItemAPI.getTopBottom();
							// Ignore all the non contextual top bottom modifiers
							// smarts only understand top bottom with context
							if (topBottomSpec && topBottomSpec.context) {
								const translatedSpec = Utils.translateTopBottom2IR({
									id: dataItemAPI.getId(),
									itemId: dataItemAPI.getColumnId(),
									selection: {
										topBottom: topBottomSpec
									}
								});
								topBottomItems.push(translatedSpec);
							}
						});
				});
			return topBottomItems;
		}

		static getUnboundColumnsIds(visualization){
			//UnboundColumnIds are columns which are available for binding to target recommendations
			//ie: they were bound to the source visualization but are unbound in the context of recommendation input.
			const mappings = visualization.getSlots().getMappingInfoList().filter(mappingInfo => mappingInfo.indexInSlot > -1);
			const dataItems = mappings.length ? mappings.map(me => me.dataItem) : visualization.getSlots().getDataItemList();
			return Utils.filterInvalidDataItems(dataItems).map(dataItem => dataItem.getColumnId());
		}

		static filterInvalidDataItems(list){
			return list.filter((dataItem) => (!SlotAPIHelper.isMultiMeasuresSeriesOrValueDataItem(dataItem) && !dataItem.isColumnUnavailable()));
		}

		static getFilterItems(visualization) {
			const result = [];
			IRUtils.localFilters2IRFilters(visualization.getLocalFilters().getFilterList(), result);
			return result;
		}
	};
});
